import { render, staticRenderFns } from "./Mines.vue?vue&type=template&id=874e497a&"
import script from "./Mines.vue?vue&type=script&lang=js&"
export * from "./Mines.vue?vue&type=script&lang=js&"
import style0 from "./Mines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports